

$(function() {
    // $('.mapclick').click(function () {
    //     $('.results').fadeOut();
    //     $('.mapselector').show();
    //
    //     var urlmap = '/map';
    //     $.ajax({
    //         url : urlmap,
    //         dataType : 'html',
    //         success : function(code, statut){
    //             //console.log(code);
    //             $('.mapselector .mapbox').html(code);
    //         },
    //
    //         error : function(resultat, statut, erreur){
    //             console.log('error');
    //             console.log(resultat);
    //             console.log(statut);
    //             console.log(erreur);
    //         },
    //
    //         complete : function(resultat, statut){
    //         }
    //     });
    //     return false;
    // });

    // $("#startCov").geocomplete({
    //     details: "form",
    //     types: ["(cities)"]
    // }).bind("geocode:result", function(event, result){
    //     $('#geoType').val(result.types[0]);
    //     var geocoder= new google.maps.Geocoder();
    //     var lat = $('#lat').val();
    //     var lng = $('#lng').val();
    //
    //     var latlng = new google.maps.LatLng(lat, lng);
    //     geocoder.geocode({'latLng': latlng}, function(results, status) {
    //         if (status == google.maps.GeocoderStatus.OK) {
    //             if (results[0]) {
    //                 var elt = results[0].address_components;
    //                 for(i in elt){
    //
    //                     console.log(elt[i]);
    //                     if(elt[i].types[0] == 'postal_code')
    //                         $('#geoCodePostal').val(elt[i].long_name);
    //                     //if(elt[i].types[0] == 'administrative_area_level_2') {
    //                         //alert(elt[i].long_name);
    //                         //if(elt[i].long_name == 'Haute-Corse' || elt[i].long_name == 'Corse-du-Sud') elt[i].long_name = 'Corse';
    //                         //$('#departement').val(elt[i].long_name.cleanURL()).trigger('change');
    //                     //}
    //                 }
    //
    //             }
    //         } else {
    //             //alert("Geocoder failed due to: " + status);
    //         }
    //     });
    //
    //
    // });

    /*$("#startCov")
        .geocomplete({
            details: "form",
            types: ["locality"]
        })
        .bind("geocode:result", function(event, result){
            $('#geoType').val(result.types[0]);
        });*/
    // $.datepicker.setDefaults( $.datepicker.regional[ "fr" ] );
    // $( "#dateStart" ).datepicker({
    //     changeMonth: true,
    //     dateFormat: "dd/mm/yy",
    //     maxDate: "{!! $festival->dateEnd !!}",
    //     onClose: function( selectedDate ) {
    //         $( "#dateEnd" ).datepicker( "option", "minDate", selectedDate );
    //     }
    // });
    // $( "#dateEnd" ).datepicker({
    //     changeMonth: true,
    //     dateFormat: "dd/mm/yy",
    //     minDate: "{!! $festival->dateStart !!}",
    //     onClose: function( selectedDate ) {
    //         $( "#dateStart" ).datepicker( "option", "maxDate", selectedDate );
    //     }
    // });
});


function initMap() {
    if($('#map').length) {
      if ($('#map').data('lat') && $('#map').data('lng')) {

        console.log('**ss*');
        var lat = $('#map').data('lat');
        var lng = $('#map').data('lng');
        var draggable = $(window).width() > 1050 ? true : false;
        var map = new google.maps.Map(document.getElementById('map'), {
          zoom: 7,
          center: {lat: lat, lng: lng},
          streetViewControl: false,
          scrollwheel: true,
          draggable: draggable,
          navigationControl: false,
          scaleControl: false,
          mapTypeControl: false
        });

        var styles = [
          {
            "featureType": "administrative",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#394648"
              }
            ]
          },
          {
            "featureType": "administrative.country",
            "elementType": "geometry.stroke",
            "stylers": [
              {
                "visibility": "on"
              },
              {
                "color": "#889091"
              }
            ]
          },
          {
            "featureType": "landscape",
            "elementType": "all",
            "stylers": [
              {
                "color": "#ebecec"
              }
            ]
          },
          {
            "featureType": "road.highway",
            "elementType": "geometry",
            "stylers": [
              {
                "visibility": "on"
              }
            ]
          },
          {
            "featureType": "road.highway",
            "elementType": "labels",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "poi",
            "elementType": "all",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "poi.business",
            "elementType": "geometry.fill",
            "stylers": [
              {
                "visibility": "on"
              }
            ]
          },
          {
            "featureType": "road",
            "elementType": "all",
            "stylers": [
              {
                "saturation": -100
              },
              {
                "lightness": 45
              }
            ]
          },
          {
            "featureType": "road.highway",
            "elementType": "all",
            "stylers": [
              {
                "visibility": "simplified"
              }
            ]
          },
          {
            "featureType": "road.arterial",
            "elementType": "labels.icon",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "transit",
            "elementType": "all",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "water",
            "elementType": "all",
            "stylers": [
              {
                "color": "#b4d4e1"
              },
              {
                "visibility": "on"
              }
            ]
          }
        ];
        map.setOptions({styles: styles});

        setMarkers(map);
      }
    }
}

// Data for the markers consisting of a name, a LatLng and a zIndex for the
// order in which these markers should display on top of each other.
var beaches = [
    [$('#map').data('name'), $('#map').data('lat'), $('#map').data('lng'), 4]
];

function setMarkers(map) {
    // Adds markers to the map.

    // Marker sizes are expressed as a Size of X,Y where the origin of the image
    // (0,0) is located in the top left of the image.

    // Origins, anchor positions and coordinates of the marker increase in the X
    // direction to the right and in the Y direction down.
    var image = {
        url: '/assets/img/marker-map.png',
        // This marker is 20 pixels wide by 32 pixels high.
        size: new google.maps.Size(32, 30),
        // The origin for this image is (0, 0).
        origin: new google.maps.Point(0, 0),
        // The anchor for this image is the base of the flagpole at (0, 32).
        anchor: new google.maps.Point(0, 32)
    };
    // Shapes define the clickable region of the icon. The type defines an HTML
    // <area> element 'poly' which traces out a polygon as a series of X,Y points.
    // The final coordinate closes the poly by connecting to the first coordinate.
    var shape = {
        coords: [1, 1, 1, 20, 18, 20, 18, 1],
        type: 'poly'
    };
    for (var i = 0; i < beaches.length; i++) {
        var beach = beaches[i];
        var marker = new google.maps.Marker({
            position: {lat: beach[1], lng: beach[2]},
            map: map,
            icon: image,
            shape: shape,
            title: beach[0],
            zIndex: beach[3]
        });
    }
}